// src/hooks/useFullObjectData.ts
import { useMemo } from "react";
import {IFullObjectData, IProcessedObjectData, TPmoAndMiscProfileNames} from "../../constants/objects/ObjectTypes/common";
import {ISignVariant} from "../../constants/objects/ObjectTypes/sign";

const useFullObjectData = (
  selectedCategory: string,
  selectedName: string,
  selectedVersion: number | null,
  selectedVariant: string,
  objCatToData: IProcessedObjectData
): IFullObjectData | null => {
  return useMemo((): IFullObjectData | null => {
    if (selectedCategory && selectedName && selectedVersion !== null && selectedVariant) {
      const objectData = objCatToData[selectedCategory][selectedName][selectedVersion];
      const variantId = objectData.variants[selectedVariant];
      let variantData = null;

      if (objectData.object.type === "Potentially Moving Object" || objectData.object.type === "Miscellaneous") {
        variantData = objectData.object.parameters[selectedVariant as TPmoAndMiscProfileNames];
      } else if (objectData.object.type === "Sign") {
        variantData = objectData.object.signVariants.find((variant: ISignVariant) => variant.id === variantId);
      }

      if (!variantId) {
        return null;
      }

      return {
        fullObjectData: objectData.object,
        variantData,
        selectedVariant,
        variantId
      };
    }
    return null;
  }, [selectedCategory, selectedName, selectedVersion, selectedVariant, objCatToData]);
};

export default useFullObjectData;